define('controller',['require','backbone','marionette','views/content/home','views/content/admin_home','views/content/cd_home','views/content/distributor_home','views/content/reseller_home','views/content/reseller_passive_home','views/content/reseller_passive_home','views/content/signin','views/content/forgot_password','views/content/reset_password','views/content/reseller_application','views/content/reseller_application','views/content/customer_application','views/content/customer_registration','models/password_reset','views/content/cd_settings','views/content/distributor_settings','views/content/reseller_settings','views/content/customer_settings','views/content/country_distributors','views/content/country_distributor','models/country_distributor','views/content/cd_managers','views/content/cd_manager','models/cd_manager','views/content/distributors','views/content/distributor','models/distributor','views/content/distributor_managers','views/content/distributor_manager','models/distributor_manager','models/reseller_application','views/content/resellers','views/content/reseller','models/reseller','views/content/reseller_managers','views/content/reseller_manager','models/reseller_manager','models/reseller_application','views/content/customers','views/content/customer','models/customer','views/content/customer_managers','views/content/customer_manager','models/customer_manager','views/content/leads','views/content/lead','models/lead','views/content/products','views/content/product','models/product','views/content/product_categories','views/content/product_category','models/product_category','views/content/store','views/content/market','views/content/market_usa','views/content/checkout','views/content/cd_licenses','views/content/cd_license','models/cd_product','views/content/distributor_licenses','views/content/distributor_license','models/distributor_product','views/content/reseller_licenses','views/content/reseller_license','models/reseller_product','views/content/customer_licenses','views/content/customer_license','models/customer_product','views/content/periodic_licenses','views/content/recurring_license','views/content/recurring_licenses','models/recurring_product','views/content/orders','views/content/distributor_personals','views/content/distributor_personal','models/distributor_personal','views/content/cd_personals','views/content/cd_personal','models/cd_personal','views/content/reseller_personals','views/content/reseller_personal','models/reseller_personal','views/content/cd_roles','views/content/cd_role','models/cd_role','views/content/distributor_roles','views/content/distributor_role','models/distributor_role','views/content/reseller_roles','views/content/reseller_role','models/reseller_role','views/content/get_payment','views/content/payments','views/content/payment','models/manual_payment','views/content/reports/sales','views/content/reports/reseller_sales','views/content/reports/reseller_sales','views/content/reports/country_sales','views/content/reports/leads','views/content/reports/inactive_resellers','views/content/reports/inactive_resellers','views/content/reports/comparison','views/content/reports/ip_history','views/content/reports/reseller_revenues','views/content/reports/cd_stocks','views/content/reports/distributor_stocks','views/content/reports/reseller_activity','views/content/reports/reseller_revenues','views/content/reports/reseller_stocks','views/content/reports/reseller_activity','views/content/reports/applications','views/content/reports/upcoming_licenses','views/content/reports/resellers','views/content/reports/resellers','views/content/reports/customers','views/content/wallet_histories','views/content/timeline','views/content/metrik','views/content/metrik_user_registration','models/metrik_user','views/content/blacklist','views/content/email_verify','views/content/go_order_licenses','views/content/go_order_license'],function(require){

    var Backbone = require('backbone');
    require('marionette');

    var HomeView = require('views/content/home');
    var AdminHomeView = require('views/content/admin_home');
    var CDHomeView = require('views/content/cd_home');
    var DistributorHomeView = require('views/content/distributor_home');
    var ResellerHomeView = require('views/content/reseller_home');
    var DistributorPassiveHomeView = require('views/content/reseller_passive_home');
    var ResellerPassiveHomeView = require('views/content/reseller_passive_home');
    var SigninView = require('views/content/signin');
    var ForgotPasswordView = require('views/content/forgot_password');
    var ResetPasswordView = require('views/content/reset_password');
    var DistributorApplicationView = require('views/content/reseller_application');
    var ResellerApplicationView = require('views/content/reseller_application');
    var CustomerApplicationView = require('views/content/customer_application');
    var CustomerRegistrationView = require('views/content/customer_registration');
    var PasswordResetModel = require('models/password_reset');

    var CDSettingsView = require('views/content/cd_settings');
    var DistributorSettingsView = require('views/content/distributor_settings');
    var ResellerSettingsView = require('views/content/reseller_settings');
    var CustomerSettingsView = require('views/content/customer_settings');

    var CDsView = require('views/content/country_distributors');
    var CDView = require('views/content/country_distributor');
    var CDModel = require('models/country_distributor');
    var CDManagersView = require('views/content/cd_managers');
    var CDManagerView = require('views/content/cd_manager');
    var CDManagerModel = require('models/cd_manager');

    var DistributorsView = require('views/content/distributors');
    var DistributorView = require('views/content/distributor');
    var DistributorModel = require('models/distributor');
    var DistributorManagersView = require('views/content/distributor_managers');
    var DistributorManagerView = require('views/content/distributor_manager');
    var DistributorManagerModel = require('models/distributor_manager');
    var DistributorApplicationModel = require('models/reseller_application');

    var ResellersView = require('views/content/resellers');
    var ResellerView = require('views/content/reseller');
    var ResellerModel = require('models/reseller');
    var ResellerManagersView = require('views/content/reseller_managers');
    var ResellerManagerView = require('views/content/reseller_manager');
    var ResellerManagerModel = require('models/reseller_manager');
    var ResellerApplicationModel = require('models/reseller_application');

    var CustomersView = require('views/content/customers');
    var CustomerView = require('views/content/customer');
    var CustomerModel = require('models/customer');
    var CustomerManagersView = require('views/content/customer_managers');
    var CustomerManagerView = require('views/content/customer_manager');
    var CustomerManagerModel = require('models/customer_manager');

    var LeadsView = require('views/content/leads');
    var LeadView = require('views/content/lead');
    var LeadModel = require('models/lead');

    var ProductsView = require('views/content/products');
    var ProductView = require('views/content/product');
    var ProductModel = require('models/product');
    var ProductCategoriesView = require('views/content/product_categories');
    var ProductCategoryView = require('views/content/product_category');
    var ProductCategoryModel = require('models/product_category');

    var StoreView = require('views/content/store');
    var MarketView = require('views/content/market');
    var MarketUSAView = require('views/content/market_usa');
    var CheckoutView = require('views/content/checkout');

    var CDLicensesView = require('views/content/cd_licenses');
    var CDLicenseView = require('views/content/cd_license');
    var CDProductModel = require('models/cd_product');

    var DistributorLicensesView = require('views/content/distributor_licenses');
    var DistributorLicenseView = require('views/content/distributor_license');
    var DistributorProductModel = require('models/distributor_product');

    var ResellerLicensesView = require('views/content/reseller_licenses');
    var ResellerLicenseView = require('views/content/reseller_license');
    var ResellerProductModel = require('models/reseller_product');

    var CustomerLicensesView = require('views/content/customer_licenses');
    var CustomerLicenseView = require('views/content/customer_license');
    var CustomerProductModel = require('models/customer_product');
    var PeriodicLicensesView = require('views/content/periodic_licenses');

    var RecurringLicenseView = require('views/content/recurring_license');    
    var RecurringLicensesView = require('views/content/recurring_licenses');   
    var RecurringLIcenseModel = require('models/recurring_product'); 

    var OrdersView = require('views/content/orders');

    var DistributorPersonalsView = require('views/content/distributor_personals');
    var DistributorPersonalView = require('views/content/distributor_personal');
    var DistributorPersonalModel = require('models/distributor_personal');

    var CDPersonalsView = require('views/content/cd_personals');
    var CDPersonalView = require('views/content/cd_personal');
    var CDPersonalModel = require('models/cd_personal');

    var ResellerPersonalsView = require('views/content/reseller_personals');
    var ResellerPersonalView = require('views/content/reseller_personal');
    var ResellerPersonalModel = require('models/reseller_personal');

    var CDRolesView = require('views/content/cd_roles');
    var CDRoleView = require('views/content/cd_role');
    var CDRoleModel = require('models/cd_role');

    var DistributorRolesView = require('views/content/distributor_roles');
    var DistributorRoleView = require('views/content/distributor_role');
    var DistributorRoleModel = require('models/distributor_role');

    var ResellerRolesView = require('views/content/reseller_roles');
    var ResellerRoleView = require('views/content/reseller_role');
    var ResellerRoleModel = require('models/reseller_role');

    var GetPaymentView = require('views/content/get_payment');
    var PaymentsView = require('views/content/payments');
    var PaymentView = require('views/content/payment');
    var PaymentModel = require('models/manual_payment');

    var SalesReportsView = require('views/content/reports/sales');
    var DistributorSalesReportsView = require('views/content/reports/reseller_sales');
    var ResellerSalesReportsView = require('views/content/reports/reseller_sales');
    var CountrySalesReportsView = require('views/content/reports/country_sales');
    var LeadsReportsView = require('views/content/reports/leads');
    var InactiveDistributorsReportsView = require('views/content/reports/inactive_resellers');
    var InactiveResellersReportsView = require('views/content/reports/inactive_resellers');
    var ComparisonReportsView = require('views/content/reports/comparison');
    var IPHistoryReportsView = require('views/content/reports/ip_history');
    var DistributorRevenueReportsView = require('views/content/reports/reseller_revenues');
    var CDStocksReportsView = require('views/content/reports/cd_stocks');
    var DistributorStocksReportsView = require('views/content/reports/distributor_stocks');
    var DistributorActivityReportsView = require('views/content/reports/reseller_activity');
    var ResellerRevenueReportsView = require('views/content/reports/reseller_revenues');
    var ResellerStocksReportsView = require('views/content/reports/reseller_stocks');
    var ResellerActivityReportsView = require('views/content/reports/reseller_activity');
    var ApplicationReportsView = require('views/content/reports/applications');
    var UpcomingLicensesView = require('views/content/reports/upcoming_licenses');
    var DistributorReportsView = require('views/content/reports/resellers');
    var ResellerReportsView = require('views/content/reports/resellers');
    var CustomerReportsView = require('views/content/reports/customers');
    
    var WalletHistoryView = require('views/content/wallet_histories');

    var TimelineView = require("views/content/timeline");

    var MetrikView = require("views/content/metrik");
    var MetrikUserRegisterView = require("views/content/metrik_user_registration");
    var MetrikUserModel = require('models/metrik_user');


    var BlacklistView = require('views/content/blacklist');

    var EmailVerifyView = require('views/content/email_verify');

    var GoOrderLicensesView = require('views/content/go_order_licenses');
    var GoOrderLicenseView = require('views/content/go_order_license');


    return Backbone.Marionette.Controller.extend({

        home: function(){
            if (App.user) {
                if (App.user.get('is_staff') && !App.user.get('groups')) {
                    App.contentRegion.show(new AdminHomeView());
                }
                else if (App.user.get('is_staff') && App.user.get('groups')) {
                    App.contentRegion.show(new LeadsView());
                }
                else if (App.user.get('country_distributor')) {
                    if (App.user.get('status') == 1) {
                        // Active Country Distributor
                        App.contentRegion.show(new CDHomeView());
                    } else {
                        // Passive Country Distributor
                        App.contentRegion.show(new DistributorPassiveHomeView());
                    }
                }
                else if (App.user.get('distributor')) {
                    if (App.user.get('status') == 1) {
                        // Active Distributor
                        App.contentRegion.show(new DistributorHomeView());
                    } else {
                        // Passive Distributor
                        App.contentRegion.show(new DistributorPassiveHomeView());
                    }
                }
                else if (App.user.get('reseller')) {
                    if (App.user.get('status') == 1) {
                        // Active reseller
                        App.contentRegion.show(new ResellerHomeView());
                    } else {
                        // Passive reseller
                        App.contentRegion.show(new ResellerPassiveHomeView());
                    }
                }
                else if (App.user.get('customer')) {
                    App.contentRegion.show(new CustomerLicensesView());
                } else {
                    App.contentRegion.show(new HomeView());
                }
            } else {
                App.context.redirect('/signin');
            }
        },

        signin: function () {
            App.contentRegion.show(new SigninView());
        },

        forgotPassword: function () {
            var passwordReset = new PasswordResetModel();

            App.contentRegion.show(new ForgotPasswordView({
                model: passwordReset
            }));
        },

        resetPassword: function (resetCode) {
            App.contentRegion.show(new ResetPasswordView({
                code: resetCode
            }));
        },

        distributorApplication: function () {
            var distributor_application = new DistributorApplicationModel();
            App.contentRegion.show(new DistributorApplicationView({
                model: distributor_application
            }));
        },

        resellerApplication: function () {
            var reseller_application = new ResellerApplicationModel();
            App.contentRegion.show(new ResellerApplicationView({
                model: reseller_application
            }));
        },

        customerApplication: function () {
            var lead = new LeadModel();
            App.contentRegion.show(new CustomerApplicationView({
                model: lead
            }));
        },

        customerRegistration: function () {
            var customer = new CustomerModel();
            App.contentRegion.show(new CustomerRegistrationView({
                model: customer
            }));
        },

        settings: function(){
            if (App.user || App.user.get('role_object').settings>1) {
                if (App.user.get('country_distributor')  ) {
                    App.contentRegion.show(new CDSettingsView());
                } else if (App.user.get('distributor')  ) {
                    App.contentRegion.show(new DistributorSettingsView());
                } else if (App.user.get('reseller')) {
                    App.contentRegion.show(new ResellerSettingsView());
                } else if (App.user.get('customer')) {
                    App.contentRegion.show(new CustomerSettingsView());
                } else {
                    App.context.redirect('/');
                }
            } else {
                App.context.redirect('/signin');
            }
        },

        country_distributors: function () {
            if (App.user && (App.user.get('is_staff') )) {
                App.contentRegion.show(new CDsView());
            } else {
                App.context.redirect('/');
            }
        },

        country_distributor: function (cdId) {
            if (App.user && App.user.get('is_staff')) {
                var country_distributor = new CDModel({
                    id: cdId
                });

                country_distributor.fetch({
                    success: function () {
                        App.contentRegion.show(new CDView({
                            model: country_distributor
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        newCountryDistributor: function () {
            if (App.user && App.user.get('is_staff')) {
                var country_distributor = new CDModel();

                App.contentRegion.show(new CDView({
                    model: country_distributor
                }));

            } else {
                App.context.redirect('/');
            }
        },

        cdManagers: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new CDManagersView());
            } else {
                App.context.redirect('/');
            }
        },

        cdManager: function (managerId) {
            if (App.user && App.user.get('is_staff')) {
                var manager = new CDManagerModel({
                    id: managerId
                });

                manager.fetch({
                    success: function () {
                        App.contentRegion.show(new CDManagerView({
                            model: manager
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        distributors: function () {
            if (App.user && (App.user.get('is_staff') || (App.user.get('role_object').distributors > 1))) {
                App.contentRegion.show(new DistributorsView());
            } else {
                App.context.redirect('/');
            }
        },

        distributor: function (distributorId) {
            if (App.user && App.user.get('is_staff') || App.user.get('role_object').distributors > 1) {
                var distributor = new DistributorModel({
                    id: distributorId
                });

                distributor.fetch({
                    success: function () {
                        App.contentRegion.show(new DistributorView({
                            model: distributor
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        newDistributor: function () {
            if (App.user && App.user.get('is_staff') || App.user.get('role_object').distributor_add > 1) {
                var distributor = new DistributorModel();

                App.contentRegion.show(new DistributorView({
                    model: distributor
                }));

            } else {
                App.context.redirect('/');
            }
        },

        distributorManagers: function () {
            if (App.user && App.user.get('is_staff') || App.user.get('role_object').distributors > 1 ) {
                App.contentRegion.show(new DistributorManagersView());
            } else {
                App.context.redirect('/');
            }
        },

        distributorManager: function (managerId) {
            if (App.user && App.user.get('is_staff') || App.user.get('role_object').distributors > 1 ) {
                var manager = new DistributorManagerModel({
                    id: managerId
                });

                manager.fetch({
                    success: function () {
                        App.contentRegion.show(new DistributorManagerView({
                            model: manager
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        resellers: function () {
            if (App.user && (App.user.get('is_staff')|| App.user.get('role_object').resellers > 1)) {
                App.contentRegion.show(new ResellersView());
            }else {
                App.context.redirect('/');
            }
        },

        reseller: function (resellerId) {
            if (App.user && (App.user.get('is_staff')|| App.user.get('role_object').resellers>1)) {
                var reseller = new ResellerModel({
                    id: resellerId
                });

                reseller.fetch({
                    success: function () {
                        App.contentRegion.show(new ResellerView({
                            model: reseller
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        newReseller: function () {
            if (App.user && (App.user.get('is_staff')|| App.user.get('role_object').reseller_add>2 )) {
                var reseller = new ResellerModel();

                App.contentRegion.show(new ResellerView({
                    model: reseller
                }));

            } else {
                App.context.redirect('/');
            }
        },

        resellerManagers: function () {
            if (App.user && (App.user.get('is_staff') || App.user.get('role_object').resellers > 1 )) {
                App.contentRegion.show(new ResellerManagersView());
            } else {
                App.context.redirect('/');
            }
        },

        resellerManager: function (managerId) {
            if (App.user && ( App.user.get('is_staff') || App.user.get('role_object').resellers > 1 ) ) {
                var manager = new ResellerManagerModel({
                    id: managerId
                });

                manager.fetch({
                    success: function () {
                        App.contentRegion.show(new ResellerManagerView({
                            model: manager
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        customers: function () {
            if (App.user.get('is_staff') || App.user.get('role_object').customers > 1) {
                App.contentRegion.show(new CustomersView());
            } else {
                App.context.redirect('/');
            }
        },

        customer: function (customerId) {
            if (App.user && (App.user.get('is_staff') || App.user.get('role_object').customers > 1 )) {
                var customer = new CustomerModel({
                    id: customerId
                });

                customer.fetch({
                    success: function () {
                        App.contentRegion.show(new CustomerView({
                            model: customer
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        newCustomer: function () {
            if (App.user.get('is_staff') || App.user.get('role_object').customer_add > 2 ) {
                var customer = new CustomerModel();

                App.contentRegion.show(new CustomerView({
                    model: customer
                }));

            } else {
                App.context.redirect('/');
            }
        },

        customerManagers: function () {
            if (App.user && ( App.user.get('is_staff') ||  App.user.get('role_object').customers > 1 ))  {
                App.contentRegion.show(new CustomerManagersView());
            } else {
                App.context.redirect('/');
            }
        },

        customerManager: function (managerId) {
            if (App.user && ( App.user.get('is_staff') ||  App.user.get('role_object').customers > 1 ))  {
                var manager = new CustomerManagerModel({
                    id: managerId
                });

                manager.fetch({
                    success: function () {
                        App.contentRegion.show(new CustomerManagerView({
                            model: manager
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        leads: function () {
            if (App.user.get('is_staff') || App.user.get('role_object').leads > 1 )  {
                App.contentRegion.show(new LeadsView());
            } else {
                App.context.redirect('/');
            }
        },

        lead: function (leadId) {
            if (App.user.get('is_staff') || App.user.get('role_object').leads > 1 )  {
                var lead = new LeadModel({
                    id: leadId
                });

                lead.fetch({
                    success: function () {
                        App.contentRegion.show(new LeadView({
                            model: lead
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        newLead: function () {
            if (App.user.get('is_staff') || App.user.get('role_object').lead_add > 2 ) {
                var lead = new LeadModel();

                App.contentRegion.show(new LeadView({
                    model: lead
                }));

            } else {
                App.context.redirect('/');
            }
        },

        products: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new ProductsView());
            } else {
                App.context.redirect('/');
            }
        },

        product: function (productId) {
            if (App.user && App.user.get('is_staff')) {
                var product = new ProductModel({
                    id: productId
                });

                product.fetch({
                    success: function () {

                        if (!product.attributes.translations.en) {
                            product.attributes.translations.en = {
                                name: null,
                                info: null
                            };
                        }

                        if (!product.attributes.translations.tr) {
                            product.attributes.translations.tr = {
                                name: null,
                                info: null
                            };
                        }

                        App.contentRegion.show(new ProductView({
                            model: product
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        newProduct: function () {
            if (App.user && App.user.get('is_staff')) {
                var product = new ProductModel();

                App.contentRegion.show(new ProductView({
                    model: product
                }));

            } else {
                App.context.redirect('/');
            }
        },

        productCategories: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new ProductCategoriesView());
            } else {
                App.context.redirect('/');
            }
        },

        productCategory: function (categoryId) {
            if (App.user && App.user.get('is_staff')) {
                var category = new ProductCategoryModel({
                    id: categoryId
                });

                category.fetch({
                    success: function () {
                        App.contentRegion.show(new ProductCategoryView({
                            model: category
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        newProductCategory: function () {
            if (App.user && App.user.get('is_staff')) {
                var category = new ProductCategoryModel();

                App.contentRegion.show(new ProductCategoryView({
                    model: category
                }));

            } else {
                App.context.redirect('/');
            }
        },

        store: function () {
            if (App.user) {
                App.contentRegion.show(new StoreView());
            }else {
                App.context.redirect('/');
            }
        },

        market: function () {
            App.contentRegion.show(new MarketView());
        },

        marketUsa: function () {
            App.contentRegion.show(new MarketUSAView());
        },

        checkout: function () {
            if (App.user) {
                App.contentRegion.show(new CheckoutView());
            } else {
                App.context.redirect('/');
            }
        },

        licenses: function () {
            if (App.user.get('customer') || App.user.get('is_staff') || App.user.get('role_object').licenses > 1  ) {
                if (App.user.get('country_distributor')) {
                    App.contentRegion.show(new CDLicensesView());
                } else if (App.user.get('distributor')) {
                    App.contentRegion.show(new DistributorLicensesView());
                }else if (App.user.get('reseller')) {
                    App.contentRegion.show(new ResellerLicensesView());
                } else if (App.user.get('customer')) {
                    App.contentRegion.show(new CustomerLicensesView());
                } else {
                    App.context.redirect('/');
                }
            } else {
                App.context.redirect('/');
            }
        },

        license: function (licenseId) {
            if (App.user.get('customer') || (App.user.get('is_staff') || App.user.get('role_object').licenses > 1)) {
                if (App.user.get('country_distributor')) {
                    var cd_license = new CDProductModel({
                        id: licenseId
                    });

                    cd_license.fetch({
                        success: function () {
                            App.contentRegion.show(new CDLicenseView({
                                model: cd_license
                            }));
                        },
                        error: function() {
                            App.context.redirect('/');
                        }
                    });

                } else if (App.user.get('distributor')) {
                    var distributor_license = new DistributorProductModel({
                        id: licenseId
                    });

                    distributor_license.fetch({
                        success: function () {
                            App.contentRegion.show(new DistributorLicenseView({
                                model: distributor_license
                            }));
                        },
                        error: function() {
                            App.context.redirect('/');
                        }
                    });
                } else if (App.user.get('reseller')) {
                    var reseller_license = new ResellerProductModel({
                        id: licenseId
                    });

                    reseller_license.fetch({
                        success: function () {
                            App.contentRegion.show(new ResellerLicenseView({
                                model: reseller_license
                            }));
                        },
                        error: function() {
                            App.context.redirect('/');
                        }
                    });

                } else if (App.user.get('customer')) {
                    var customer_license = new CustomerProductModel({
                        id: licenseId
                    });

                    customer_license.fetch({
                        success: function () {
                            App.contentRegion.show(new CustomerLicenseView({
                                model: customer_license
                            }));
                        },
                        error: function() {
                            App.context.redirect('/');
                        }
                    });

                } else {
                    App.context.redirect('/');
                }
            } else {
                App.context.redirect('/');
            }
        },

        periodicLicenses: function () {
            if (App.user ) {
                if (App.user.get('is_staff')){
                    App.contentRegion.show(new PeriodicLicensesView());
                } else if ( App.user.get('reseller')  && App.user.get('role_object').periodic_licenses > 1) {
                    App.contentRegion.show(new PeriodicLicensesView());
                } else {
                    App.context.redirect('/');
                }
            } else {
                App.context.redirect('/');
            }
        },

        recurringLicenses: function () {
            if(App.user){
                App.contentRegion.show(new RecurringLicensesView());
            }else{
                App.context.redirect('/');
            }
        },

        recurringLicense: function (licenseId) {
            if(App.user){

                var recurring_license = new RecurringLIcenseModel({
                    id: licenseId
                });

                recurring_license.fetch({
                    success: function(){
                        App.contentRegion.show( new RecurringLicenseView(
                            {model: recurring_license}
                        ));
                    },
                    error: function(){
                        App.context.redirect('/');
                    }
                });
                
            }else{
                App.context.redirect('/');
            }
        },

        orders: function () {

            if (App.user.get('is_staff')) {
                App.contentRegion.show(new OrdersView());
            } else if (( App.user.get('role_object').orders > 1) ){
                App.contentRegion.show(new OrdersView());
            } else {
                App.context.redirect('/');
            }
        },

        /* Personal Route Controls */

        personals: function () {
            if (App.user) {
                if (App.user.get('country_distributor') && App.user.get('role') == 1) {
                    App.contentRegion.show(new CDPersonalsView());
                }else if (App.user.get('distributor') && App.user.get('role') == 1) {
                    App.contentRegion.show(new DistributorPersonalsView());
                }else if (App.user.get('reseller') && App.user.get('role') == 1) {
                    App.contentRegion.show(new ResellerPersonalsView());
                }else {
                    App.context.redirect('/');
                }
            } else {
                App.context.redirect('/');
            }   
        },
        personal : function (personalId) {

            if (App.user && App.user.get('country_distributor') && App.user.get('role') == 1) {
                var cd_per = new CDPersonalModel({
                    id: personalId
                });
                cd_per.fetch({
                    success: function () {
                        App.contentRegion.show(new CDPersonalView({
                            model: cd_per
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });

            } else if (App.user && App.user.get('distributor') && App.user.get('role') == 1) {
                var per = new DistributorPersonalModel({
                    id: personalId
                });
                per.fetch({
                    success: function () {
                        App.contentRegion.show(new DistributorPersonalView({
                            model: per
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else if (App.user && App.user.get('reseller') && App.user.get('role') == 1) {
                var pers = new ResellerPersonalModel({
                    id: personalId
                });
                pers.fetch({
                    success: function () {
                        App.contentRegion.show(new ResellerPersonalView({
                            model: pers
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },
        newPersonal: function () {
            if (App.user && App.user.get('country_distributor') && App.user.get('role') == 1) {
                var cd_personal = new CDPersonalModel();

                App.contentRegion.show(new CDPersonalView({
                    model: cd_personal
                }));
            }else if (App.user && App.user.get('distributor') && App.user.get('role') == 1) {
                var personal = new DistributorPersonalModel();

                App.contentRegion.show(new DistributorPersonalView({
                    model: personal
                }));

            } else if (App.user && App.user.get('reseller') && App.user.get('role') == 1) {
                var personal1 = new ResellerPersonalModel();

                App.contentRegion.show(new ResellerPersonalView({
                    model: personal1
                }));

            } else {
                App.context.redirect('/');
            }
        },

        /* Personal Role Route Controls */

        personalRoles: function () {
            if (App.user) {
                if (App.user.get('country_distributor') && App.user.get("role") == 1) {
                    App.contentRegion.show(new CDRolesView());
                }else if (App.user.get('distributor') && App.user.get("role") == 1) {
                    App.contentRegion.show(new DistributorRolesView());
                }else if (App.user.get('reseller') && App.user.get("role") == 1) {
                    App.contentRegion.show(new ResellerRolesView());
                } else {
                    App.context.redirect('/');
                }
            } else {
                App.context.redirect('/');
            }   
        },
        personalRole : function (roleId) {

            if (App.user && App.user.get('country_distributor') && App.user.get("role") == 1) {
                var cd_role = new CDRoleModel({
                    id: roleId
                });
                cd_role.fetch({
                    success: function () {
                        App.contentRegion.show(new CDRoleView({
                            model: cd_role
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            }else if (App.user && App.user.get('distributor') && App.user.get("role") == 1) {
                var role = new DistributorRoleModel({
                    id: roleId
                });
                role.fetch({
                    success: function () {
                        App.contentRegion.show(new DistributorRoleView({
                            model: role
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else if (App.user && App.user.get('reseller') && App.user.get("role") == 1 ) {
                var role1 = new ResellerRoleModel({
                    id: roleId
                });
                role1.fetch({
                    success: function () {
                        App.contentRegion.show(new ResellerRoleView({
                            model: role1
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },
        newPersonalRole: function () {
            if (App.user && App.user.get('country_distributor') && App.user.get('role') == 1) {
                var cd_role = new CDRoleModel();

                App.contentRegion.show(new CDRoleView({
                    model: cd_role
                }));

            } else if (App.user && App.user.get('distributor') && App.user.get('role') == 1) {
                var role = new DistributorRoleModel();

                App.contentRegion.show(new DistributorRoleView({
                    model: role
                }));

            } else if (App.user && App.user.get('reseller') && App.user.get('role') == 1) {
                var role2 = new ResellerRoleModel();

                App.contentRegion.show(new ResellerRoleView({
                    model: role2
                }));

            } else {
                App.context.redirect('/');
            }
        },

        getPayment: function () {
            if (App.user && App.user.get('role_object').get_payment > 1) {
                App.contentRegion.show(new GetPaymentView());
            } else {
                App.context.redirect('/');
            }
        },

        payments: function () {
            if (App.user.get('is_staff') || App.user.get('role_object').payments > 1) {
                App.contentRegion.show(new PaymentsView());
            } else {
                App.context.redirect('/');
            }
        },

        payment: function (paymentId) {
            if (App.user.get('is_staff') || App.user.get('role_object').payments > 1) {
                var payment = new PaymentModel({
                    id: paymentId
                });

                payment.fetch({
                    success: function () {
                        App.contentRegion.show(new PaymentView({
                            model: payment
                        }));
                    },
                    error: function() {
                        App.context.redirect('/');
                    }
                });
            } else {
                App.context.redirect('/');
            }
        },

        salesReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new SalesReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        distributorSalesReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new DistributorSalesReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        resellerSalesReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new ResellerSalesReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        countrySalesReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new CountrySalesReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        leadsReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new LeadsReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        inactiveDistributorsReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new InactiveDistributorsReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        inactiveResellersReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new InactiveResellersReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        comparisonReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new ComparisonReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        ipHistoryReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new IPHistoryReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        distributorRevenueReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new DistributorRevenueReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        cdStockReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new CDStocksReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        distributorStockReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new DistributorStocksReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        distributorActivityReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new DistributorActivityReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        resellerRevenueReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new ResellerRevenueReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        resellerStockReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new ResellerStocksReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        resellerActivityReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new ResellerActivityReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        applicationReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new ApplicationReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        distributorReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new DistributorReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        resellerReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new ResellerReportsView());
            } else {
                App.context.redirect('/');
            }
        },

        customerReports: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new CustomerReportsView());
            } else {
                App.context.redirect('/');
            }
        },



        blacklist: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new BlacklistView());
            } else {
                App.context.redirect('/');
            }
        },



        upcomingLicenses: function () {
            if (App.user && App.user.get('is_staff')) {
                App.contentRegion.show(new UpcomingLicensesView());
            } else {
                App.context.redirect('/');
            }
        },
        wallets: function () {
            if (App.user && (App.user.get('is_staff') || App.user.get('role_object').wallets > 1 )) {
                App.contentRegion.show(new WalletHistoryView());
            } else {
                App.context.redirect('/');
            }   
        },
        
        timeline: function () {
            if (App.user && (App.user.get('customer') || App.user.get('role_object').timeline > 1)) {
                App.contentRegion.show(new TimelineView());
            } else {
                App.context.redirect('/');
            }   
        },

        metrik: function () {
            if (App.user && (App.user.get('customer'))) {
                App.contentRegion.show(new MetrikView());
            } else {
                App.context.redirect('/');
            }   
        },

        metrikUserRegistration: function (registerCode) {
            if (registerCode) {
                App.contentRegion.show(new MetrikUserRegisterView({
                    code: registerCode,
                    model: new MetrikUserModel()
                }));
            } else {
                App.context.redirect('/');
            }   
        },


        verify: function (verifyCode) {
            App.contentRegion.show(new EmailVerifyView({
                code: verifyCode
            }));
        },

        goOrders: function (productId) {
            if (App.user && (App.user.get('is_staff')|| App.user.get('reseller') || App.user.get('customer')  ) ){
                App.contentRegion.show(new GoOrderLicensesView({
                    id: productId
                }));
            }else {
                App.context.redirect('/');
            }
        },

        goOrder: function (licenseId) {
            if (App.user && (App.user.get('is_staff')|| App.user.get('reseller') || App.user.get('customer')  ) ){
                App.contentRegion.show(new GoOrderLicenseView({
                    id: licenseId
                }));
            }else {
                App.context.redirect('/');
            }
        },


    });
});

